/**
 * Central route configuration
 * All application routes are defined in domain-specific files and combined here
 */

import { Common } from "lib/types"
import { dashboardRoutes } from "./dashboardRoutes"
import { orderRoutes } from "./orderRoutes"
import { productRoutes } from "./productRoutes"
import { discountRoutes } from "./discountRoutes"
import { campaignRoutes } from "./campaignRoutes"
import { storeRoutes } from "./storeRoutes"
import { customerRoutes } from "./customerRoutes"
import { settingsRoutes } from "./settingsRoutes"
import { workflowRoutes } from "./workflowRoutes"
import { errorRoutes } from "./errorRoutes"

/**
 * All application routes combined
 * Routes are automatically filtered by user groups in routes.tsx
 */
export const allRoutes: Common.Views = [
  ...dashboardRoutes,
  ...discountRoutes,
  ...campaignRoutes,
  ...orderRoutes,
  ...customerRoutes,
  ...productRoutes,
  ...storeRoutes,
  ...workflowRoutes,
  ...settingsRoutes,
  ...errorRoutes
]

// Re-export individual route groups for testing or specific use cases
export {
  dashboardRoutes,
  orderRoutes,
  productRoutes,
  discountRoutes,
  campaignRoutes,
  storeRoutes,
  customerRoutes,
  workflowRoutes,
  settingsRoutes,
  errorRoutes
}
